import { Box, Divider, Paragraph } from '@ui'

export const TownAbout = (props: { aboutTown: string; withDivider?: boolean }) => {
    const { aboutTown, withDivider } = props

    return aboutTown ? (
        <>
            {withDivider && <Divider />}
            <Box gap="lg">
                <Paragraph strong size="lg" color="default">
                    About the Town
                </Paragraph>
                <Paragraph>{aboutTown}</Paragraph>
            </Box>
        </>
    ) : null
}
